<ul class="mixed-loyalty-nav">
  <a class="nav-item" [routerLink]="['/payment']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
    <label>{{ 'navbar.payment' | translate }}</label>
  </a>
  <a class="nav-item" [routerLink]="['/ecashhistory']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
    <label>{{ 'nav.ecash.history' | translate }}</label>
  </a>
</ul>
